// Import icons
/*
import assetMonitoringIcon from "../../assets/images/HOSTSDISC_Dashboard.svg";
import dnsHealthIcon from "../../assets/images/DNS_Dashboard.svg";
import subdomainHealthIcon from "../../assets/images/SUBDOM_Dashboard.svg";
import knownVulnerabilitiesIcon from "../../assets/images/VULNERAB_Dashboard.svg";
import sslCertificatesIcon from "../../assets/images/SSLCERT_Dashboard.svg";
import webTechnologiesIcon from "../../assets/images/menu_icons/WebTechnologies_Dashboard.svg";
import brandMentionsIcon from "../../assets/images/menu_icons/BrandMentions_Dashboard.svg";
import fakeMobileAppsIcon from "../../assets/images/FAKEAPP_Dashboard.svg";
import lookAlikeDomainsIcon from "../../assets/images/image-gallery/Icon_1.svg";
import fakeSocialMediaIcon from "../../assets/images/FAKESME_Dashboard.svg";
import stolenCredentialsIcon from "../../assets/images/STOLENCRED_Dashboard.svg";
import malwareInfectedIcon from "../../assets/images/image-gallery/malware_infected_computers.svg";
import sourceCodeLeakageIcon from "../../assets/images/LEAKAGE_Dashboard.svg";
import leakedSessionsIcon from "../../assets/images/menu_icons/LeakedSession_Dashboard.svg";
import openCloudBucketsIcon from "../../assets/images/menu_icons/OpenCloudBuckets_Dashboard.svg";
import ipBlacklistsIcon from "../../assets/images/BLACKIP_Dashboard.svg";
import personalInfoIcon from "../../assets/images/menu_icons/PIL_Dashboard.svg";
import darkWebIcon from "../../assets/images/BLACKIP_Dashboard.svg";
import pastebinIcon from "../../assets/images/LEAKAGE_Dashboard.svg";
import postmanIcon from "../../assets/images/menu_icons/WebTechnologies_Dashboard.svg";
import telegramIcon from "../../assets/images/menu_icons/BrandMentions_Dashboard.svg";
*/

import assetMonitoringIcon from "../../../assets/images/Identify_Valkyrie.svg";
import dnsHealthIcon from "../../../assets/images/Identify_Valkyrie.svg";
import subdomainHealthIcon from "../../../assets/images/Identify_Valkyrie.svg";
import knownVulnerabilitiesIcon from "../../../assets/images/Identify_Valkyrie.svg";
import sslCertificatesIcon from "../../../assets/images/Identify_Valkyrie.svg";
import webTechnologiesIcon from "../../../assets/images/Identify_Valkyrie.svg";
import brandMentionsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import fakeMobileAppsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import lookAlikeDomainsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import fakeSocialMediaIcon from "../../../assets/images/Identify_Valkyrie.svg";
import stolenCredentialsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import malwareInfectedIcon from "../../../assets/images/Identify_Valkyrie.svg";
import sourceCodeLeakageIcon from "../../../assets/images/Identify_Valkyrie.svg";
import leakedSessionsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import openCloudBucketsIcon from "../../../assets/images/Identify_Valkyrie.svg"
import ipBlacklistsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import personalInfoIcon from "../../../assets/images/Identify_Valkyrie.svg";
import darkWebIcon from "../../../assets/images/Identify_Valkyrie.svg";
import pastebinIcon from "../../../assets/images/Identify_Valkyrie.svg";
import postmanIcon from "../../../assets/images/Identify_Valkyrie.svg";
import telegramIcon from "../../../assets/images/Identify_Valkyrie.svg";

export const scansSubcategories = [
  {
    id: "asset_monitoring",
    title: "Asset Monitoring",
    icon: assetMonitoringIcon
  },
  {
    id: "dns_health",
    title: "DNS Health",
    icon: dnsHealthIcon
  },
  {
    id: "subdomain_health",
    title: "Subdomain Health",
    icon: subdomainHealthIcon
  },
  {
    id: "known_vulnerabilities",
    title: "Known Vulnerabilities",
    icon: knownVulnerabilitiesIcon
  },
  {
    id: "ssl_certificates",
    title: "SSL Certificates",
    icon: sslCertificatesIcon
  },
  {
    id: "web-technologies",
    title: "Web Technologies",
    icon: webTechnologiesIcon
  },
  {
    id: "brand_mentions",
    title: "Brand Mentions",
    icon: brandMentionsIcon
  },
  {
    id: "fake_mobile_applications",
    title: "Fake Mobile Applications",
    icon: fakeMobileAppsIcon
  },
  {
    id: "look_alike",
    title: "Look-alike Domains",
    icon: lookAlikeDomainsIcon
  },
  {
    id: "fake_social_media_profiles",
    title: "Fake Social Media Profiles",
    icon: fakeSocialMediaIcon
  },
  {
    id: "stolen_credentials",
    title: "Stolen Credentials",
    icon: stolenCredentialsIcon
  },
  {
    id: "malware_infected_computers",
    title: "Malware Infected Computers",
    icon: malwareInfectedIcon
  },
  {
    id: "source_code_leakage",
    title: "Source Code Leakage",
    icon: sourceCodeLeakageIcon
  },
  {
    id: "leaked_sessions",
    title: "Leaked Sessions",
    icon: leakedSessionsIcon
  },
  {
    id: "open-cloud-buckets",
    title: "Open Cloud Buckets",
    icon: openCloudBucketsIcon
  },
  {
    id: "ip_blacklist",
    title: "IP Blacklists",
    icon: ipBlacklistsIcon
  },
  {
    id: "personal_information_leakage",
    title: "Personal Information Leakage",
    icon: personalInfoIcon
  },
  {
    id: "dark_web_monitoring",
    title: "Dark Web Monitoring",
    icon: darkWebIcon
  },
  {
    id: "pastebin_search",
    title: "Pastebin Search",
    icon: pastebinIcon
  },
  {
    id: "postman_monitoring",
    title: "Postman Monitoring",
    icon: postmanIcon
  },
  {
    id: "telegram_monitoring",
    title: "Telegram Monitoring",
    icon: telegramIcon
  }
];